var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFortunaLogoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.476,
    height: 77.845,
    viewBox: "0 0 77.476 77.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1566",
    "data-name": "Group 1566",
    transform: "translate(-40.993 -9.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    d: "M123.176,60.523A38.738,38.738,0,1,1,84.438,21.6a38.8,38.8,0,0,1,38.738,38.923",
    transform: "translate(-4.707 -11.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    d: "M104.8,60.707A20.131,20.131,0,1,1,84.669,40.484,20.139,20.139,0,0,1,104.8,60.707m18.376-.185A38.738,38.738,0,1,0,84.438,99.445a38.8,38.8,0,0,0,38.738-38.923",
    transform: "translate(-4.707 -11.627)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortunaLogoCircle);
export default __webpack_public_path__ + "static/media/fortuna_logo_circle.cffb5a36ebc268783756fbd56f651362.svg";
export { ForwardRef as ReactComponent };